import { Route } from 'src/routes/Route'

export const SignInRoute = Route({ path: '/sign-in' })
export type SignInRoute = Route<typeof SignInRoute>
